import { Event } from '@/models/jgrow/event';
import { ApiService } from './api.service';
import { ActiveEntryMatrix, UserSurveyWithActiveEntryMatrix } from '@/models/jgrow/survey-answer';

class SurveyAnalyzeService extends ApiService {
  constructor() {
    super();
  }
  /**
   * イベント一覧取得
   */
  getEvent(eventID: number): Promise<Event> {
    const url = `/jgrow/event/${eventID}`;
    return this.get(Event, url, {});
  }

  /**
   * 全回答情報取得
   */
  getAnswers(eventID: number): Promise<UserSurveyWithActiveEntryMatrix> {
    const url = `/event/answer?eventID=${eventID}`;
    return this.get(UserSurveyWithActiveEntryMatrix, url, {});
  }

  /**
   * コンピテンシー成長分析
   */
  getListCompetencyPulsAnalysis(eventID: number, beforeEvalSettingID: number, afterEvalSettingID: number): Promise<ActiveEntryMatrix[]> {
    const url = `/jgrow/event/analysis?eventID=${eventID}&beforeEvalSettingID=${beforeEvalSettingID}&afterEvalSettingID=${afterEvalSettingID}`;
    return this.getList(ActiveEntryMatrix, url, {});
  }
}

export const surveyAnalyzeService = new SurveyAnalyzeService();
